import type { CreateDocumentItemDTO } from "./types";

function round2(n: number): number {
  return Math.round(n * 100) / 100;
}

export type ComputedDocumentTotals = {
  subtotal: number;
  discountAmount: number;
  taxAmount: number;
  total: number;
  lines: Array<{
    orderIndex: number;
    description: string;
    detail: string | null;
    quantity: number;
    unit: string | null;
    unitPrice: number;
    discountAmount: number;
    taxRate: number;
    lineTotal: number;
  }>;
};

/**
 * ຄິດໄລ່ຍອດລວມຈາກລາຍການ — ກົງກັບ create-document / update-document
 */
export function computeDocumentTotalsFromItems(
  items: CreateDocumentItemDTO[],
  docDiscount: number,
  docTaxRate: number,
): ComputedDocumentTotals {
  const lines = items.map((item, i) => {
    const lineSub =
      item.quantity * item.unitPrice - (item.discountAmount ?? 0);
    const lineTotal = round2(lineSub);
    return {
      orderIndex: i,
      description: item.description?.trim() || "—",
      detail: item.detail?.trim() ? item.detail.trim() : null,
      quantity: item.quantity,
      unit: item.unit?.trim() || null,
      unitPrice: item.unitPrice,
      discountAmount: item.discountAmount ?? 0,
      taxRate: item.taxRate ?? 0,
      lineTotal,
    };
  });

  const subtotal = round2(lines.reduce((sum, row) => sum + row.lineTotal, 0));
  const taxAmount = round2((subtotal - docDiscount) * docTaxRate);
  const total = round2(subtotal - docDiscount + taxAmount);

  return {
    subtotal,
    discountAmount: docDiscount,
    taxAmount,
    total,
    lines,
  };
}
